import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import i18n from 'i18next';
export interface IParams {
    pageNumber: number;
    sortby: {
        columName: string;
        type: string;
    };
    filter: {
        categoryId: number;
        parentCategoryId: number;
        countryId: number;
        regionId: number;
        cityId: number;
        fromPrice: number;
        toPrice: number;
        categories: Array<any>;
    };
    lang: string;
    search: string;
    userId: number;
    showCurrency: string;
}

const initialParams = {
    pageNumber: 1,
    sortby: {
        columName: 'createdDate',
        type: 'desc'
    },
    filter: {
        categoryId: 0,
        parentCategoryId: 0,
        countryId: 0,
        regionId: 0,
        cityId: 0,
        fromPrice: -1,
        toPrice: -1,
        categories: [],
        categoryDetails: []
    },
    lang: i18n.language,
    search: '',
    userId: 0,
    showCurrency: ''
};

// export const fetchItems = createAsyncThunk('params/fetchItems', async (params: IParams) => {
//     const response = await fetch('/api/items');
//     return response.json();
// });

export const fetchItems = createAsyncThunk(
    'params/fetchItems',
    async (params: IParams) => {
        const response = await fetch('/api/items', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params),
        });
        if (!response.ok) {
            throw new Error('Failed to fetch items');
        }
        return response.json();
    }
);

export const paramsSlice = createSlice({
    name: 'params',
    initialState: initialParams,
    reducers: {
        setParams: (state, action: PayloadAction<IParams>) => {
            //@ts-ignore
            state = action.payload;
        },
        resetParams: () => initialParams,
        setUserId: (state, action: PayloadAction<number>) => {
            state.userId = action.payload;
        },
        setCategoryId: (state, action: PayloadAction<number>) => {
            state.filter.categoryId = action.payload;
        },
        addDeatilIds: (state, action: PayloadAction<number>) => {
            //@ts-ignore
            if (!state.filter.categories.includes(action.payload)){
                        //@ts-ignore
                state.filter.categories.push(action.payload);
            }else{
                state.filter.categories = state.filter.categories.filter((item) => item !== action.payload);
            }

         
        },
        addDeatilIdsFilter: (state, action: PayloadAction<any>) => {
            //@ts-ignore
            if (state.filter.categoryDetails[0]&&state.filter.categoryDetails[0].Id==action.payload?.parentId){
                //@ts-ignore
                state.filter.categoryDetails[0].Value = action.payload?.Id;
                //@ts-ignore
                state.filter.categoryDetails[0].Id = action.payload?.parentId;
                
            }else{
                //@ts-ignore\
                state.filter.categoryDetails[0] = {
                    Id: action.payload?.Id,
                    Value: 0
                };
            }
            
        },
        addDeatilIdsFilterId: (state, action: PayloadAction<any>) => {
            //@ts-ignore    
            state.filter.categoryDetails[0] = action.payload;
        },
        setParentCategoryId: (state, action: PayloadAction<number>) => {
            state.filter.parentCategoryId = action.payload;
        },
        setFilter: (state, action: PayloadAction<IParams['filter']>) => {
            //@ts-ignore
            state.filter = action.payload;
        },
        setLang: (state, action: PayloadAction<string>) => {
            state.lang = action.payload;
        },
        setSearch: (state, action: PayloadAction<string>) => {
            state.search = action.payload;
        },
        setPageNumber: (state, action: PayloadAction<number>) => {
            state.pageNumber = action.payload;
        },
        setSortBy: (state, action: PayloadAction<IParams['sortby']>) => {
            //@ts-ignore
            state.sortby = action.payload;
        },
        setCountryId: (state, action: PayloadAction<number>) => {
            state.filter.countryId = action.payload;
        },
        setRegionId: (state, action: PayloadAction<number>) => {
            state.filter.regionId = action.payload;
        },
        setCityId: (state, action: PayloadAction<number>) => {
            state.filter.cityId = action.payload;
        }
    }
});

export const { setParams, resetParams, setUserId, setCategoryId, setParentCategoryId, setFilter, setLang, setSearch, setPageNumber, setSortBy, setCountryId, setRegionId, setCityId,addDeatilIds, addDeatilIdsFilter } =
    paramsSlice.actions;

export default paramsSlice.reducer;

export { selectParams, selectParamsFilter, selectParamsSortBy, ParamsInRedux } from '../selectors';
